import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const captchaSlice = createSlice({
  name: "captcha",
  initialState: { captcha: false },
  reducers: {
    setCaptcha: (state, action) => {
      state.captcha = action.payload;
    },
  },
});

// Экшены
export const { setCaptcha } = captchaSlice.actions;

export default captchaSlice.reducer;
